import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/PositionsApi/Positions";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import EditPositionsForm from "./components/EditPositionsForm";
import fields from "../json/Positions.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import { PositionRules } from "validation/ValidationRules";


const EditPositions = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        PositionRules
    );

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );


    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Update({ id, data: formValues });
        },
        (vals) => {

            const err = validateForm(vals, PositionRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Position updated successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <EditPositionsForm
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
            />
        </>
    );
};

export default EditPositions;
